<script lang="ts">
	import { Button } from '$lib/components/ui/button';
	import { DotIcon, PlayIcon } from 'lucide-svelte';
	import { fade } from 'svelte/transition';
	import { PUBLIC_CDN_URL, PUBLIC_LOL_CDN_URL } from '$env/static/public';
	import GuiToolbar from '../gui-toolbar.svelte';
	import { cn } from '$lib/utils';

	let className: string = '';
	export { className as class };
</script>

<div
	class={cn(
		'relative h-[850px] w-[640px] flex-col items-center rounded-lg border border-darkTertiary bg-darkPrimaryAlt px-5 py-2 shadow-lg backdrop-blur',
		className
	)}
>
	<GuiToolbar class="h-2.5 w-auto" />
	<div class="flex h-full w-full">
		<div class="flex h-full w-full flex-col items-center justify-center">
			<div
				class={cn('flex h-full w-full max-w-4xl flex-col items-start justify-start gap-6 py-10')}
			>
				<div class="flex w-full flex-row items-start justify-start gap-3">
					<div
						class="flex h-8 max-h-7 min-h-7 w-7 min-w-7 max-w-9 overflow-hidden rounded-full bg-darkQuaternary pt-0.5 shadow-glow shadow-darkQuaternary drop-shadow-lg transition-all"
					>
						<img
							src={`${PUBLIC_CDN_URL}/meeko/meeko_1.png?fm=webp`}
							class="block h-9 max-h-9 w-auto object-cover p-1"
							alt="Meeko"
						/>
					</div>
					<div class="flex w-full flex-col items-start justify-start gap-1">
						<span class="text-xs font-light text-lightTertiary">Meeko</span>

						<div
							in:fade={{ duration: 300 }}
							class="flex w-full flex-col items-start justify-center gap-3 pr-12"
						>
							<p class="max-w-xl text-xs text-lightSecondary">
								Here are a couple of VODs for the <img
									src={`${PUBLIC_LOL_CDN_URL}/champion/Akali.png?fm=webp`}
									class="inline h-5 w-auto rounded-full"
									alt="Akali"
								/>
								Akali vs
								<img
									src={`${PUBLIC_LOL_CDN_URL}/champion/Sylas.png?fm=webp`}
									class="inline h-5 w-auto rounded-full"
									alt="Sylas"
								/>
								Sylas matchup in the mid lane from a
								<img src="/images/lol/rank/diamond.png" class="inline h-4 w-auto" alt="Diamond" /> Diamond
								rank analysis.
							</p>
							<!-- VODs -->
							<div
								class="flex h-auto w-full flex-col items-center justify-center overflow-x-scroll rounded-lg bg-darkTertiary p-1"
							>
								<div class="flex w-full flex-col items-start justify-between gap-4 p-3">
									<div class="flex w-full flex-col items-start justify-start gap-4">
										<a
											href="https://www.youtube.com/watch?v=jnRFzsoeozA"
											target="_blank"
											class="group relative flex h-24 w-44 items-center justify-center rounded-lg bg-darkSecondary transition-all"
										>
											<img
												src={`${PUBLIC_CDN_URL}/lol/thumbnails/1.png?fm=webp`}
												alt="Thumbnail 1"
												class="absolute h-full w-full rounded-lg object-cover opacity-75 transition-all group-hover:opacity-100"
											/>
											<PlayIcon
												class="z-50 h-5 w-5 stroke-lightPrimary stroke-2 font-light transition-all group-hover:fill-red-700 group-hover:stroke-red-700"
											/>
										</a>
										<div class="flex w-full max-w-xs flex-col items-start justify-start gap-1">
											<span class="text-sm font-normal">
												Beifeng Akali vs Sylas on CN Super Server
											</span>
											<div class="flex w-full items-center gap-1 text-xs font-light">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/champion/Akali.png?fm=webp`}
													class="inline h-4 w-auto rounded-full"
													alt="Akali"
												/>
												Akali <DotIcon class="h-4 w-auto text-lightQuaternary" />
												<span class="tracking-widest"
													>24/<span class="text-lightTertiary">1</span>/7</span
												>
											</div>
										</div>
									</div>
									<Button
										href="https://www.youtube.com/watch?v=jnRFzsoeozA"
										target="_blank"
										class="rounded-lg bg-darkQuaternary font-light hover:bg-red-700"
										size="sm">Watch on YouTube</Button
									>
								</div>
								<div
									class="flex w-full flex-row items-center justify-start rounded-lg bg-darkSecondary p-1"
								>
									<span class="p-3 text-xs text-lightTertiary">
										In this game, Beifeng showcases how to properly play the Sylas matchup and how
										he converts his lane advantage to a win
									</span>
								</div>
							</div>
							<div
								class="flex h-auto w-full flex-col items-center justify-center overflow-x-scroll rounded-lg bg-darkTertiary p-1"
							>
								<div class="flex w-full flex-col items-start justify-between gap-4 p-3">
									<div class="flex w-full flex-col items-start justify-start gap-4">
										<a
											href="https://www.youtube.com/watch?v=FDZCArU2bso"
											target="_blank"
											class="group relative flex h-24 w-44 items-center justify-center rounded-lg bg-darkSecondary transition-all"
										>
											<img
												src={`${PUBLIC_CDN_URL}/lol/thumbnails/2.png?fm=webp`}
												alt="Thumbnail 2"
												class="absolute h-full w-full rounded-lg object-cover opacity-75 transition-all group-hover:opacity-100"
											/>
											<PlayIcon
												class="z-50 h-5 w-5 stroke-lightPrimary stroke-2 font-light transition-all group-hover:fill-red-700 group-hover:stroke-red-700"
											/>
										</a>
										<div class="flex w-full max-w-xs flex-col items-start justify-start gap-1">
											<span class="text-sm font-normal">Faker Akali vs Sylas Challenger KR</span>
											<div class="flex w-full items-center gap-1 text-xs font-light">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/champion/Akali.png?fm=webp`}
													class="inline h-4 w-auto rounded-full"
													alt="Akali"
												/>
												Akali <DotIcon class="h-4 w-auto text-lightQuaternary" />
												<span class="tracking-widest"
													>13/<span class="text-lightTertiary">0</span>/5</span
												>
											</div>
										</div>
									</div>
									<Button
										href="https://www.youtube.com/watch?v=FDZCArU2bso"
										target="_blank"
										class="rounded-lg bg-darkQuaternary font-light hover:bg-red-700"
										size="sm">Watch on YouTube</Button
									>
								</div>
								<div
									class="flex w-full flex-row items-center justify-start rounded-lg bg-darkSecondary p-1"
								>
									<span class="p-3 text-xs text-lightTertiary">
										Here Faker shows his champion mastery of Akali going deathless in a challenger
										game on the Korean server
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
